import BatteryInformation from 'src/components/ConnectedVehicle/BatteryInformation/BatteryInformation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(BatteryInformation);